import React, { useEffect } from "react";

/**
 * Tiny SEO helper without external deps — manipulates document head directly.
 * Sets title, description, OG tags, and canonical for each page.
 */
const SEO = ({ title, description, path = "/" }) => {
  useEffect(() => {
    const fullTitle = `${title} · Masika Chem SARL`;
    document.title = fullTitle;

    const ensure = (selector, create) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = create();
        document.head.appendChild(el);
      }
      return el;
    };

    const desc = ensure('meta[name="description"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("name", "description");
      return m;
    });
    desc.setAttribute("content", description || "");

    const og = [
      ["og:title", fullTitle],
      ["og:description", description || ""],
      ["og:type", "website"],
      ["og:site_name", "Masika Chem SARL"],
    ];
    og.forEach(([prop, val]) => {
      const m = ensure(`meta[property="${prop}"]`, () => {
        const x = document.createElement("meta");
        x.setAttribute("property", prop);
        return x;
      });
      m.setAttribute("content", val);
    });

    const canonical = ensure('link[rel="canonical"]', () => {
      const l = document.createElement("link");
      l.setAttribute("rel", "canonical");
      return l;
    });
    canonical.setAttribute("href", `${window.location.origin}${path}`);
  }, [title, description, path]);

  return null;
};

export default SEO;
